import { createFileRoute } from '@tanstack/react-router';

import { ProjectSettingsPage } from '@/features/projects/settings-page';

export const Route = createFileRoute('/_app/projects/$projectId/settings')({
  component: ProjectSettings,
});

function ProjectSettings() {
  const { projectId } = Route.useParams();
  return <ProjectSettingsPage projectId={projectId} />;
}
